export default "__VITE_ASSET__D41Nq2M0__"